import { useTranslation } from "react-i18next";
import { COMISSION_RULES, RULES } from "./Rule";
import RuleTable from "./RuleTable";

const COMMON_TEXT_STYLE =
  "text-xs sm:text-sm mb-[5px] text-light-text leading-5";

const RuleDetail = ({ noTable }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`referral.${key}`);

  return (
    <section className="bg-input-color dark:bg-base-light-dark p-[16px] rounded-[10px] text-transaction-text">
      {RULES.map((rule, INDEX) => {
        return (
          <div
            key={INDEX}
            className={`${INDEX !== RULES.length - 1 && "mb-[20px]"}`}
          >
            <p className="text-xs font-semibold text-transaction-text dark:text-base-light-white">
              {INDEX + 1}. {i18n(`Rule.tip${INDEX + 1}`)}
            </p>
            <div className="list-disc">
              {rule.details.map((detail, index) => {
                return (
                  <li className={COMMON_TEXT_STYLE} key={index}>
                    {i18n(`Rule.detail${INDEX + 1}.${index + 1}`)}
                  </li>
                );
              })}
            </div>

            {noTable || (
              <>
                <p className="text-xs font-semibold text-gold-text my-[15px] sm:text-xl">
                  {i18n("Reward Calculation")}:
                </p>
                <RuleTable />
              </>
            )}
            {/* <p className="text-xs font-semibold text-gold-text my-[15px] sm:text-xl">
              {i18n("Rule.example.title")}:
            </p>
            <p className={COMMON_TEXT_STYLE}>
              {i18n("Rule.example.sentences.1")}
            </p>
            <p className="text-xs font-semibold text-gold-text my-[15px] sm:text-xl">
              {i18n("Rule.example.calculation.1")}
            </p>
            <p className={COMMON_TEXT_STYLE}>
              {i18n("Rule.example.calculation.2")}
            </p>
            <p className={COMMON_TEXT_STYLE}>
              {i18n("Rule.example.calculation.3")}{" "}
            </p>
            <p className={COMMON_TEXT_STYLE}>
              {i18n("Rule.example.calculation.4")}{" "}
            </p>
            <p className={COMMON_TEXT_STYLE}>
              {i18n("Rule.example.calculation.5")}
            </p> */}
            {/* <section className="list-disc">
              <li className={COMMON_TEXT_STYLE}>
                <span className="text-gold-text">
                  {i18n("Rule.example.calculation.6")}{" "}
                </span>
                <p className={COMMON_TEXT_STYLE}>
                  29,000,000÷10,000×160=464,000
                </p>
              </li>
              <li className={COMMON_TEXT_STYLE}>
                {i18n("Rule.example.calculation.7")}{" "}
                <span className="text-gold-text">
                  {i18n("Rule.example.calculation.8")}{" "}
                </span>
              </li>
              <li className={COMMON_TEXT_STYLE}>
                {i18n("Rule.example.calculation.9")}{" "}
                <span className="text-gold-text">
                  {i18n("Rule.example.calculation.10")}{" "}
                </span>
                <p className={COMMON_TEXT_STYLE}>
                  9,000,000÷10,000×120=108,000
                </p>
              </li>
              <li className={COMMON_TEXT_STYLE}>
                {i18n("Rule.example.calculation.11")}{" "}
                <span className="text-gold-text">
                  {i18n("Rule.example.calculation.12")}{" "}
                </span>
                <p className={COMMON_TEXT_STYLE}>4,000,000÷10,000×100=40,000</p>
              </li>
              <li className={COMMON_TEXT_STYLE}>
                <span className="text-gold-text">
                  {i18n("Rule.example.calculation.13")}
                </span>
                <p className={COMMON_TEXT_STYLE}>
                  464,000-108,000-40,000=316,000
                </p>
              </li>
            </section> */}
            <p className="text-xs font-semibold text-gold-text my-[15px] sm:text-xl">
              {i18n("Rule.example.notice.1")}
            </p>
            <section className="list-disc">
              <li className={COMMON_TEXT_STYLE}>
                {i18n("Rule.example.notice.2")}
              </li>
              <li className={COMMON_TEXT_STYLE}>
                {i18n("Rule.example.notice.3")}
              </li>
              <li className={COMMON_TEXT_STYLE}>
                {i18n("Rule.example.notice.4")}
              </li>
            </section>
            <p className="text-gold-text font-bold">
              {i18n("Rule.example.notice.5")}
            </p>
          </div>
        );
      })}
    </section>
  );
};

export default RuleDetail;
